/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type {
  AuthPasswordResetOptions,
  AuthPasswordResetResponses,
} from '../models/AuthPasswordReset'
import {
  authPasswordResetResponseSchema,
  authPasswordResetErrorSchema,
  authPasswordResetBodySchema,
} from '../schemas/authPasswordResetSchema'

/**
 * @summary Complete a password reset with the emailed token + a new password; on success the user is logged in (V4 pair issued).
 * {@link /api/v4/auth/password/reset}
 */
export function authPasswordReset<ThrowOnError extends boolean = true>(
  options: Options<AuthPasswordResetOptions, ThrowOnError>
): Unwrappable<RequestResult<AuthPasswordResetResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/password/reset',
      validator: {
        request: authPasswordResetBodySchema,
        response: authPasswordResetResponseSchema,
        error: authPasswordResetErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<AuthPasswordResetResponses, ThrowOnError>>
  )
}
